/**
 * 路测关注区测试项 Hook
 *
 * 职责：
 * 管理路测关注区测试项列表的加载和状态
 */
import { useState, useCallback } from 'react';
import { mapEditorFetch } from '../utils/fetch';
import { HttpStatusCode } from '@/fetch/core/constant';

export interface RoadTestItem {
  itemName: string;
  itemNo: string;
}

export const useRoadTestItems = () => {
  const [roadTestItems, setRoadTestItems] = useState<RoadTestItem[]>([]);
  const [isLoadingItems, setIsLoadingItems] = useState<boolean>(false);
  const [itemsError, setItemsError] = useState<string | null>(null);

  const fetchRoadTestItemList = useCallback(async () => {
    setIsLoadingItems(true);
    setItemsError(null);
    try {
      const res = await mapEditorFetch.getRoadTestItemList();
      if (res.code === HttpStatusCode.Success && res.data?.itemList) {
        setRoadTestItems(res.data.itemList);
      } else {
        setItemsError('获取测试项列表失败');
      }
    } catch (error) {
      setItemsError('获取测试项列表失败');
    } finally {
      setIsLoadingItems(false);
    }
  }, []);

  return {
    roadTestItems,
    isLoadingItems,
    itemsError,
    fetchRoadTestItemList,
  };
};
